import type { StatusBadgeTone } from '@immo/ui-kit';
import type { LandIqDataRunEntryState, LandIqDataRunFailureReason } from '@immo/api-contract';

export const STATE_TONES: Record<LandIqDataRunEntryState, StatusBadgeTone> = {
  PENDING: 'neutral',
  BLOCKED: 'warning',
  RUNNING: 'info',
  DONE: 'success',
  FAILED: 'danger',
};

/** A failure because the publisher was down: amber, not red — retry later, not a bug. */
export const SOURCE_OUTAGE_TONE: StatusBadgeTone = 'warning';

/**
 * True when a FAILED state failed because its source was down. A missing field, null or an unknown
 * reason reads as a plain failure.
 */
export function isSourceOutage(
  state: string | null,
  failureReason: LandIqDataRunFailureReason | null | undefined,
): boolean {
  return state === 'FAILED' && failureReason === 'SOURCE_OUTAGE';
}
